module.exports = __webpack_public_path__ + "media/images/dubai-32432fe04b4ed69bde78714d462f6bb9.jpg";